import { FormState, LookupRequest, LookupType } from '../types';

/**
 * Converts form-level state into a query-level request config.
 * Used for handling form submission and performing a lookup query.
 */
export const getLookupRequestFromFormState = ({
  identifier,
  lookupType,
}: FormState): LookupRequest => {
  switch (lookupType) {
    case LookupType.ByUserId:
      return { userId: identifier };
    case LookupType.ByEmail:
    default:
      return { email: identifier };
  }
};
